import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { modalId: String };

  connect() {
    this.boundHandleModalClose = this.handleModalClose.bind(this);
    document.addEventListener("close.hs.overlay", this.boundHandleModalClose);
  }

  disconnect() {
    document.removeEventListener("close.hs.overlay", this.boundHandleModalClose);
  }

  handleModalClose(event) {
    if (!this.hasModalIdValue) return;

    const isCloseButton = event.target.dataset?.hsOverlay === `#${this.modalIdValue}`;
    const isModalElement = event.target.id === this.modalIdValue;

    if (isCloseButton || isModalElement) {
      this.resetProgress();
    }
  }

  resetProgress() {
    const modal = document.getElementById(this.modalIdValue);
    if (!modal) return;

    const progressEl = modal.querySelector("[data-controller~='progress']");
    if (!progressEl) return;

    progressEl.dataset.currentStep = 1;

    progressEl.querySelectorAll("[role='progressbar']").forEach((bar, index) => {
      const fill = bar.children[0];
      bar.setAttribute("aria-valuenow", index === 0 ? 10 : 0);
      fill.style.width = index === 0 ? "10%" : "0%";
    });

    progressEl.querySelectorAll("[data-progress-target='step']").forEach((step, index) => {
      step.classList.toggle("hidden", index !== 0);
    });

    const stepCounter = progressEl.querySelector("[data-progress-target='currentStep']");
    if (stepCounter) stepCounter.textContent = 1;

    const backButton = progressEl.querySelector("[data-progress-target='backButton']");
    if (backButton) backButton.classList.add("hidden");

    const nextButton = progressEl.querySelector("[data-progress-target='nextButton']");
    if (nextButton) nextButton.classList.remove("hidden");

    const submitButton = progressEl.querySelector("[data-progress-target='submitButton']");
    if (submitButton) submitButton.classList.add("hidden");
  }
}
